import React from 'react'
import SuperAdminSidebar from './SuperAdminSidebar'

const SuperAdminLayout = () => {
    return (
        <SuperAdminSidebar />
    )
}

export default SuperAdminLayout